// Single place every page calls to report an ecommerce event.
//
// Call sites used to import from utils/pixel directly, which meant Meta got the
// event and GA4 got nothing. Routing everything through this facade keeps the two
// platforms in step: add a call here once and both receive it.
//
// Signatures match the old utils/pixel ones so existing call sites only had to
// change their import path.

import {
  trackViewContent, trackAddToCart, trackInitiateCheckout, trackPurchase, trackPageView,
} from './pixel';
import { gaViewItem, gaAddToCart, gaBeginCheckout, gaPurchase, gaPageView } from './ga4';

export function analyticsViewItem(product) {
  trackViewContent(product);
  gaViewItem(product);
}

export function analyticsAddToCart(item) {
  trackAddToCart(item);
  gaAddToCart(item);
}

// `items` may be ids (Meta only needs ids) or full objects (GA4 wants name,
// price and quantity to populate its product reports).
export function analyticsBeginCheckout({ items = [], value = 0 } = {}) {
  trackInitiateCheckout({ items: items.map((i) => (typeof i === 'object' ? i.product_id ?? i.id : i)), value });
  gaBeginCheckout({ items, value });
}

export function analyticsPurchase({ orderKey, items = [], value = 0, shipping = 0 } = {}) {
  trackPurchase({ orderKey, items: items.map((i) => (typeof i === 'object' ? i.product_id ?? i.id : i)), value });
  gaPurchase({ orderKey, items, value, shipping });
}

export function analyticsPageView(path) {
  trackPageView();
  gaPageView(path);
}
